import { useChatStore, STREAM_TIMER_TODO_ID } from "#app/store/chat";

export type StreamTimer = {
  start: () => void;
  stop: (finalStatus?: "completed" | "failed") => void;
};

function formatDuration(ms: number): string {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes <= 0) return `${seconds}s`;
  return `${minutes}m ${seconds}s`;
}

export function createStreamTimer(todoId = STREAM_TIMER_TODO_ID): StreamTimer {
  let startedAt: number | null = null;
  let finalized = false;

  const start = () => {
    if (startedAt != null) return;
    startedAt = Date.now();
    try {
      (window as any).__svStreamStartedAt = startedAt;
    } catch {}
    try {
      const store = useChatStore.getState();
      store.addOrUpdateTodoOnLastAssistantMessage("0s", "started", todoId);
    } catch {}
  };

  const stop = (finalStatus: "completed" | "failed" = "completed") => {
    if (finalized) return;
    finalized = true;
    try {
      (window as any).__svStreamStartedAt = null;
    } catch {}
    try {
      const store = useChatStore.getState();
      const finalText =
        startedAt == null
          ? finalStatus === "completed"
            ? "Completed"
            : "Stopped"
          : `${finalStatus === "completed" ? "Completed in" : "Stopped in"} ${formatDuration(Date.now() - startedAt)}`;
      store.addOrUpdateTodoOnLastAssistantMessage(
        finalText,
        finalStatus as any,
        todoId,
      );
    } catch {}
  };

  return { start, stop };
}
